import { useQuery } from "@tanstack/react-query";
import { UserService } from "../services/usuario";

export const useUserQuery = () => {
  return useQuery({
    queryKey: ["me"],
    queryFn: UserService.getData,
  });
};
